export const PAGE_ALIGMENTS = {
    custom: "P",
    vertical: "V",
    horizontal: "H",
    both: "A"
}